<template>
  <div v-if="messages">
    <v-card
      class="mx-auto"
      style="width: 80%"
      shaped
      outlined
      v-if="!messages || messages.length == 0"
    >
      <v-card-actions>
        <v-row align="center" justify="center">
          <v-btn
            text
            @click="
              $emit(`replyAll`, {
                dadosAdicionais: JSON.stringify({
                  emails: [`${atendimento.fromID}`],
                  from: atendimento.ultimoAgente,
                }),
              })
            "
            >{{ t(`responderATodos`) }}</v-btn
          >
          <v-btn
            text
            @click="
              $emit(`encaminharMsg`, {
                dadosAdicionais: JSON.stringify({
                  emails: [`${atendimento.fromID}`],
                  from: atendimento.ultimoAgente,
                }),
              })
            "
            >{{ t(`encaminhar`) }}</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>

    <div v-for="msg in sortMsgById" :key="msg.id + `msg`" :data="msg">
      <br />
      <br />

      <div class="row">
        <v-card class="mx-auto" style="width: 80%" shaped outlined>
          <v-card-title class="text-center">
            <v-icon left> mdi-account </v-icon>
            <span class="title font-weight-light">{{ getFromName(msg) }}</span>
          </v-card-title>
          <v-card-text
            ><span>
              <b>Enviado em:</b> {{ moment(msg.dataHora).format(`llll`) }}</span
            ><br />
            <span>
              <b>Para:</b>
              {{ formatArray(msg.dadosAdicionais) }}</span
            ><br />
          </v-card-text>
          <v-card-text v-html="msg.texto"></v-card-text>
          <v-card-text>
            <v-spacer></v-spacer>

            <div
              v-for="(file, index) in msg.queueAnexos"
              :key="index + `anexos`"
            >
              <v-btn
                text
                v-if="file.mimeType && file.mimeType !== null && msg.id"
              >
                <a :href="ip + file.caminho" target="_blank">
                  <v-icon>mdi-file-download-outline</v-icon>
                  {{ getFileName(file) }}
                </a>
              </v-btn>
              <v-btn
                icon
                v-if="file.mimeType && file.mimeType !== null && !msg.id"
              >
                <a :href="file.caminho" target="_blank">
                  <v-icon>mdi-file-download-outline</v-icon>
                </a>
              </v-btn>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-row
              align="center"
              justify="center"
              v-show="msg.inOut === 1 || msg.inOut === 2"
            >
              <v-btn
                text
                @click="$emit(`replyMsg`, msg)"
                v-show="msg.inOut !== 2"
                >{{ t(`responder`) }}</v-btn
              >
              <v-btn text @click="$emit(`replyAll`, msg)">{{
                t(`responderATodos`)
              }}</v-btn>
              <v-btn text @click="$emit(`encaminharMsg`, msg)">{{
                t(`encaminhar`)
              }}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapState } from "vuex";
// import { mapActions } from "vuex";
export default {
  props: {
    messages: { type: Array },
  },
  data() {
    return {
      ip: "http://" + JSON.parse(localStorage.getItem("config")).servidor,
    };
  },
  computed: {
    ...mapState(`xc`, {
      atendimento: (state) => state.atendimento,
      clientes: (state) => state.clientes,
    }),
    sortMsgById() {
      if (!this.messages) return null;
      let msg = this.messages;
      return msg.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    moment() {
      return moment;
    },
  },
  methods: {
    getFileName(file) {
      let name = file.caminho.split(`/`);
      return name[6];
    },
    getFromName(msg) {
      if (msg.dadosAdicionais) {
        if (typeof msg.dadosAdicionais !== "object")
          return JSON.parse(msg.dadosAdicionais).from;
        return msg.dadosAdicionais.from;
      } else {
        return "Xcontact";
      }
    },
    formatArray(array) {
      if (typeof array !== "object") array = JSON.parse(array);
      if (!array) return;
      array = array.emails;
      let retorno = "";
      if (!array) return;
      for (let i = 0; i, i < array.length; i++) {
        let item = array[i];
        if (i + 1 == array.length) {
          retorno += item;
        } else {
          retorno += item + `, `;
        }
      }
      return retorno;
    },
    formataHora(dataHora) {
      moment.locale("pt-br");
      if (moment(dataHora).format("L") === moment(new Date()).format("L")) {
        return moment(dataHora).format("LT");
      } else {
        return moment(dataHora).format("lll");
      }
    },
    formataData(dataHora) {
      moment.locale("pt-br");
      return moment(dataHora).format("L");
    },
  },
};
</script>

<style>
</style>